import React, { FC } from 'react'
import { useAppDispatch } from '../../../../hooks/useRedux'
import { Avatar, Button, Card, Col, Dropdown, Row, Typography } from 'antd'
import { useTheme } from 'styled-components'
import Icon from '../../../Icon'
import { logout } from '../../../../store/user/userActions'

const DropdownContent = () => {
  const dispatch = useAppDispatch()

  function dispatchLogout() {
    return dispatch(logout())
  }

  return (
    <Card size='small'>
      <Button type='primary' danger block onClick={dispatchLogout}>
        Logout
      </Button>
    </Card>
  )
}

const SiderAccount: FC = () => {
  const theme = useTheme()

  return (
    <div>
      <Typography.Text className='d-block text-center' type='secondary'>
        RatioSIM - Borusan ENBW
      </Typography.Text>
      <Dropdown overlay={<DropdownContent />} trigger={['click']}>
        <Card className='account-card' size='small'>
          <Row gutter={10} align='middle'>
            <Col>
              <Avatar className='mr-8' style={{ background: theme.colors.primary }}>
                <Icon icon='user' color='light' margin={false} />
              </Avatar>
            </Col>

            <Col flex={1}>
              <Typography.Text className='text-center' ellipsis={true}>
                <b>Ratio User</b>
              </Typography.Text>
            </Col>

            <Col>
              <Icon icon='angle-up' />
            </Col>
          </Row>
        </Card>
      </Dropdown>
    </div>
  )
}

export default SiderAccount
